import webBiLogger from '@wix/web-bi-logger';
import {
  BI_CRM_HOME_SRC,
  BI_CRM_HOME_USERS_END_POINT,
  biEventIds,
} from './biConsts';
import { getMandatoryBIFields } from '@wix/business-manager-api';

export class CrmHomeBiLogger {
  private readonly biLogger: any;

  constructor({ msid }: { msid: string }) {
    this.biLogger = webBiLogger
      .factory({ endpoint: BI_CRM_HOME_USERS_END_POINT })
      .updateDefaults({
        src: BI_CRM_HOME_SRC,
        msid,
        ...getMandatoryBIFields(),
      })
      .logger();
  }

  private log(data: any) {
    return this.biLogger.log(data);
  }

  reportCardButtonClicked(section: string, button_name: string) {
    return this.log({
      evid: biEventIds.CARD_BUTTON_CLICKED,
      section,
      button_name,
    });
  }

  reportCardSecondaryButtonClicked(tabName: string) {
    return this.log({
      evid: biEventIds.SECONDARY_BUTTON_CLICKED,
      tabName,
    });
  }

  reportFinancesCardButtonClicked(tabName: string) {
    return this.log({
      evid: biEventIds.FINANCES_CARD_CLICKED,
      tabName,
    });
  }

  reportCreateNewButtonClick() {
    return this.log({
      evid: biEventIds.CREATE_NEW_BUTTON_CLICKED,
    });
  }

  reportCreateNewOptionClick(option) {
    return this.log({
      evid: biEventIds.CREATE_NEW_OPTION_CLICKED,
      option,
    });
  }

  reportCarouselClick() {
    return this.log({
      evid: biEventIds.CAROUSEL_CLICKED,
    });
  }

  reportToolCardClicked(tabName: string) {
    return this.log({
      evid: biEventIds.TOOL_CLICKED,
      tabName,
    });
  }

  reportSendMessageTo(contactId) {
    return this.log({
      evid: biEventIds.SEND_MESSAGE_TO,
      contactId,
    });
  }

  reportImportContacts() {
    return this.log({
      evid: biEventIds.IMPORT_CONTACTS,
    });
  }

  reportSendMessage(contactId: string) {
    return this.log({
      evid: biEventIds.SEND_MESSAGE,
      contactId,
    });
  }

  reportViewContact(contactId: string) {
    return this.log({
      evid: biEventIds.VIEW_CONTACT,
      contactId,
    });
  }

  reportGoToWorkflows() {
    return this.log({
      evid: biEventIds.GO_TO_WORKFLOWS,
    });
  }

  reportStartWorkflowFromScratch() {
    return this.log({
      evid: biEventIds.START_FROM_SCRATCH,
    });
  }

  reportUseWorkflowTemplate(template: string) {
    return this.log({
      evid: biEventIds.USE_TEMPLATE,
      template,
    });
  }

  reportViewAllCommunicatation() {
    return this.log({
      evid: biEventIds.VIEW_ALL_COMUNNICATIONS,
    });
  }

  reportViewAllMarketing() {
    return this.log({
      evid: biEventIds.VIEW_ALL_MARKETING,
    });
  }
  reportViewAllFinance() {
    return this.log({
      evid: biEventIds.VIEW_ALL_FINANCE,
    });
  }

  reportConnectToCommunicatation(connectTab: string) {
    return this.log({
      evid: biEventIds.CONNECT_TO_COMUNNICATIONS,
      connectTab,
    });
  }

  reportConnectToMarketing(connectTab: string) {
    return this.log({
      evid: biEventIds.CONNECT_TO_MARKETING,
      connectTab,
    });
  }
  reportConnectToFinance(connectTab: string) {
    return this.log({
      evid: biEventIds.CONNECT_TO_FINANCE,
      connectTab,
    });
  }

  reportGoToMarketing() {
    return this.log({
      evid: biEventIds.GO_TO_MARKETING,
    });
  }
  reportScrollingPage() {
    return this.log({
      evid: biEventIds.SCROLL_DOWN,
    });
  }
  reportCrmHomeVideo() {
    return this.log({
      evid: biEventIds.CRM_HOME_VIDEO,
    });
  }
}
